<template>
  <v-list-group :prepend-icon="groupIcon">
    <template v-slot:activator>
      <v-list-item class="mb-0">
        <v-list-item-title>{{ groupName }}</v-list-item-title>
      </v-list-item>
    </template>
    <slot></slot>
  </v-list-group>
</template>

<script>
  export default {
    name: 'NavigationGroup',
    props: {
      groupName: String,
      groupIcon: String,
    },
  };
</script>
